// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_6Qckl","empty":"empty_8g-2H"};